/**
 * @author Ariel
 * @description 标签管理
 * @Date 2023/08/03
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";

import {framework_tool, component_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport } = component_tool;

const _getValue = (type, key) => {
  const values = {
      state: {
          '0': '无效',
          '1': '有效',
      },
      source: {
          '0': '系统',
          '1': '第三方',
      },
      tear: {
        '0': '否',
        '1': '是',
      }
  }
  return values[type][key] || ''
}

class LabelManager extends WizContainer {
  componentName = 'labelManager';

  constructor(props){
    super(props);
    this.state = {
    }
  };

  _handleCMD(nextProps, nextState, key){
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key){
    let o = nextProps[key]
    let columnSelf = {cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    }}
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标签名称',
        field: 'name',
        width: 20,
        columnSelf
      },
      {
        headerName: '标签编码',
        field: 'code',
        width: 20,
        columnSelf
      },
      {
        headerName: '标签分类',
        field: 'categoryName',
        width: 20,
        columnSelf
      },
      {
        headerName: '标签描述',
        field: 'intro',
        width: 40,
        columnSelf
      },
      {
        headerName: '标签状态',
        field: 'state',
        width: 15,
        columnSelf
      },
      {
        headerName: '标签来源',
        field: 'source',
        width: 15,
        columnSelf
      },
      {
        headerName: '标签人数',
        field: 'studentNum',
        width: 15,
        columnSelf
      },
      {
        headerName: '是否撕除标签',
        field: 'tear',
        width: 20,
        columnSelf
      },
      {
        headerName: '创建人',
        field: 'fullName',
        width: 20,
        columnSelf
      },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 30,
        columnSelf
      },
      {
        headerName: '更新时间',
        field: 'updateTime',
        width: 30,
        columnSelf
      },
    ]
    if (o['success']) {
      let data = o['data']
      if(data && data instanceof Array && data.length>0){
        data.forEach(d => {
          d.state = _getValue("state", d.state)
          d.source = _getValue("source", d.source)
          d.tear = _getValue("tear", d.tear)
        })
      }
      WizBrowserExport({
        title: '标签信息',
        sheetName: '标签信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '标签信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({jumpPage:this.jumpPage}),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        export: this._handleFile,
        treeData: this._handleTreeData,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LabelManager);
